import { Sparkles } from "lucide-react";

import {
  formatAiAssistedDisclaimer,
  type TAiAssistedDisclaimerContext,
} from "@/constants/aiDisclaimer";
import { cn } from "@/lib/utils";

type TAiAssistedDisclaimerVariant = "banner" | "compact";

type TAiAssistedDisclaimerProps = {
  variant?: TAiAssistedDisclaimerVariant;
  context?: TAiAssistedDisclaimerContext;
  className?: string;
};

const variantClasses: Record<TAiAssistedDisclaimerVariant, string> = {
  banner: "rounded-lg border border-border bg-muted/50 px-3 py-2 text-xs text-muted-foreground",
  compact: "text-xs text-muted-foreground",
};

export function AiAssistedDisclaimer({
  variant = "banner",
  context = "investment",
  className,
}: TAiAssistedDisclaimerProps) {
  const disclaimer = formatAiAssistedDisclaimer(context);

  return (
    <p
      role="note"
      aria-label={disclaimer}
      className={cn("flex items-start gap-1.5 leading-relaxed", variantClasses[variant], className)}
    >
      <Sparkles
        className="mt-0.5 h-3.5 w-3.5 shrink-0 text-muted-foreground"
        aria-hidden
      />
      <span>{disclaimer}</span>
    </p>
  );
}
